export default __webpack_public_path__ + "static/media/reschedule.cd567a17.svg";